import { parseAsArrayOf, parseAsString, useQueryStates } from "nuqs";
export const labResultsQueryParams = {
  labResultsClassification: parseAsArrayOf(parseAsString, ","),
  typeOfLab: parseAsArrayOf(parseAsString, ","),
  needsSignature: parseAsArrayOf(parseAsString, ",")
};
export function useLabResultsColumnFilters() {
  return useQueryStates(labResultsQueryParams);
}